/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import {
  Form,
  Input,
  Table,
  Modal,
  Radio,
  Select,
  DatePicker,
  Spin,
} from "antd";
/*import {
  GetJobTypelist,
  GetJobSubTypelist,
  GetJobCategory,
  UpdateJobType,
} from "../../../actions/basicData";*/
import { connect } from "react-redux";
import moment from "moment";
import { GetJobType, GetJobSubType } from "../../../api/basicData";
import Api from "../../../services/ServiceApi";
import Cookies from "js-cookie";
const { Option } = Select;
const { RangePicker } = DatePicker;

class JobType extends Component {
  formRef = React.createRef();
  formRefSub = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      columns: [
        {
          title: "Job Category Name",
          render: (item) =>
            !item.job_category_name ? "-" : item.job_category_name,
          align: "center",
          key: "job_category_name",
          sorter: (a, b) => 
          (a.job_category_name === null || a.job_category_name  === undefined ? "" : a.job_category_name).localeCompare
          (b.job_category_name === null || b.job_category_name  === undefined ? "" : b.job_category_name),         
         },
        {
          title: "Job Type ID",
          render: (item) => (!item.job_type_id ? "-" : item.job_type_id),
          align: "center",
          key: "job_type_id",
          sorter: (a, b) => a.job_type_id - b.job_type_id,
          render: (item) => (
            <a
              onClick={() =>
                this.onClickRow(item)
              }
              className="c-blue text-underline"
            >
              {item.job_type_id}
            </a>
          ),
        },
        {
          title: "Job Type Name",
          render: (item) => (!item.job_type_name ? "-" : item.job_type_name),
          align: "center",
          key: "job_type_name",
          sorter: (a, b) => 
          (a.job_type_name === null || a.job_type_name  === undefined ? "" : a.job_type_name).localeCompare
          (b.job_type_name === null || b.job_type_name  === undefined ? "" : b.job_type_name),           
        },       
        {
          title: "Effective date",
          align: "center",
          key: "effective_date",
          render: (item) =>
            !item.effective_date ? (
              "-"
            ) : (
              <div>{moment(item.effective_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) => 
            (a.effective_date === null || a.effective_date  === undefined ? "" : a.effective_date).localeCompare
            (b.effective_date === null || b.effective_date  === undefined ? "" : b.effective_date), 
        },
        {
          title: "Expire date",
          align: "center",
          key: "expire_date",
          render: (item) =>
            !item.expire_date ? (
              "-"
            ) : (
              <div>{moment(item.expire_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) => 
            (a.expire_date === null || a.expire_date  === undefined ? "" : a.expire_date).localeCompare
            (b.expire_date === null || b.expire_date  === undefined ? "" : b.expire_date), 
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          render: (item) => (
            <div>
              {item == 0 ? (
                <span></span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
          sorter: () => null,
        },
        {
          title: "Action",
          render: (item) => (
            <div>
              <a onClick={() => this.onModal("edit", true, item)}>
                <img src={Api.absoluteUrl("/icon/edit.svg")} />
              </a>
              <a onClick={() => this.onModal("delete", true, item)}>
                <img src={Api.absoluteUrl("/icon/delete.svg")} />
              </a>
            </div>
          ),
          sorter: () => null,
        },
      ],
      columns_sub: [
        {
          title: "Job Sub Type ID",
          render: (item) =>
            !item.job_sub_type_id ? "-" : item.job_sub_type_id,
          align: "center",
          key: "job_sub_type_id",
          sorter: (a, b) => 
          (a.job_sub_type_id === null || a.job_sub_type_id  === undefined ? 0 : a.job_sub_type_id) -
          (b.job_sub_type_id === null || b.job_sub_type_id  === undefined ? 0 : b.job_sub_type_id),          
        },
        {
          title: "Job Sub Type Name",
          render: (item) => (!item.job_type_name ? "-" : item.job_type_name),
          align: "center",
          key: "job_type_name",
          sorter: (a, b) => 
          (a.job_type_name === null || a.job_type_name  === undefined ? "" : a.job_type_name).localeCompare
          (b.job_type_name === null || b.job_type_name  === undefined ? "" : b.job_type_name),  
        },
        {
          title: "Job Type ID",
          render: (item) => (!item.job_type_id ? "-" : item.job_type_id),
          align: "center",
          key: "job_type_id",
          sorter: (a, b) => 
          (a.job_type_id === null || a.job_type_id  === undefined ? 0 : a.job_type_id) -
          (b.job_type_id === null || b.job_type_id  === undefined ? 0 : b.job_type_id),              
          // render: (item) => (
          //   <a
          //     onClick={() =>
          //       this.onClickRow(item)
          //     }
          //     className="c-blue text-underline"
          //   >
          //     {item.job_type_id}
          //   </a>
          // ),
        },
        {
          title: "Effective date",
          align: "center",
          key: "effective_date",
          render: (item) =>
            !item.effective_date ? (
              "-"
            ) : (
              <div>{moment(item.effective_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) => 
            (a.effective_date === null || a.effective_date  === undefined ? "" : a.effective_date).localeCompare
            (b.effective_date === null || b.effective_date  === undefined ? "" : b.effective_date),  
        },
        {
          title: "Expire date",
          align: "center",
          key: "expire_date",
          render: (item) =>
            !item.expire_date ? (
              "-"
            ) : (
              <div>{moment(item.expire_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) => 
            (a.expire_date === null || a.expire_date  === undefined ? "" : a.expire_date).localeCompare
            (b.expire_date === null || b.expire_date  === undefined ? "" : b.expire_date),  
        },
        {
          title: "Status",
          dataIndex: "status",
          sorter: () => null,
          key: "status",
          render: (item) => (
            <div>
              {item == 0 ? (
                <span></span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
        },
        {
          title: "Action",
          sorter: () => null,
          render: (item) => (
            <div>
              <a onClick={() => this.onModal("edit sub", true, item)}>
                <img src={Api.absoluteUrl("/icon/edit.svg")} />
              </a>
              <a onClick={() => this.onModal("delete sub", true, item)}>
                <img src={Api.absoluteUrl("/icon/delete.svg")} />
              </a>
            </div>
          ),
        },
      ],
      loading_modal_delete: false,
      data: [],
      master_data_job_type: [],
      data_sub: [],
      master_data_sub: [],
      visible: false,
      visible_approve: false, // for opening and closing of approve modal
      visible_reject: false,
      visible_delete: false,
      visible_sub: false,
      value: 1,
      category: [],
      sub_category: [],
      processType: null,
      modal_item: {},
      job_cat_data: [],
      data_edit : null ,
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YY"],
    };
  }

  async componentDidMount() {
    const job_type = await Api.post("/v4/get_job_type", {
      pk_id: null,
      is_active: 1,
      effective: null,
      sql_where: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      UserName: Cookies.get("username"),
    });
    //// console.log(job_type);
    this.setState({
      data: job_type.data.data,
      master_data_job_type: job_type.data.data,
    });

    const job_cat = await Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
      operator_id: Cookies.get("operator_id"),
    });
    if (job_cat.data.result.code === "P") {
      this.setState({
        category: job_cat.data.data.result_data,
      });
    } 

    const job_sub_cat = await Api.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: null,
      job_type_id: null,
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
    });
    if (job_sub_cat.data.result.code === "P") {
      
      this.setState({
        sub_category: job_sub_cat.data.data.job_sub_type_dto_list,
      });
    } 
  }

  async handleSubmit(values) {
    const { modal_item, data_edit } = this.state;
    var form = {};

    if (this.state.processType == "add") {


      form["create_by"] = Cookies.get("username");
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["project_id"] = Cookies.get("project_id");
      form["job_category_id"] = values.job_category_id;
      form["job_type_name"] = values.job_type_name;
      form["effective_date"] = moment(values.effective_date).format("YYYY-MM-DD");
      form["expire_date"] = values.expire_date != undefined ?  moment(values.expire_date).format("YYYY-MM-DD") : null;
      form["is_active"] = 1;
      form["ma_type"] = values.ma_type;
      form["form_id"] = "";
      form["data_dynamic"] = "";
      form["create_date"] = moment(new Date()).format("YYYY-MM-DD HH:mm");
      form["roworder"] = "";;
      form["job_type_id"] = null;

      console.log(form);
    

      await Api.post("v2/update_job_type", form).then((val) => {
     
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRef.current.resetFields();
          Api.post("/v4/get_job_type", {
            pk_id: null,
            is_active: 1,
            effective: null,
            sql_where: null,
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            UserName: Cookies.get("username"),
          }).then((val) => {
            // console.log(val);
            if (val.data.result.code === "P") {
              this.setState({
                data: val.data.data,
                master_data_job_type: val.data.data,
              });
            }
          });
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });
    } else if (this.state.processType == "edit") {
      ////////////////////////////////edit data main
 
      form["create_by"] = Cookies.get("username");
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["project_id"] = Cookies.get("project_id");
      form["job_category_id"] = modal_item.job_category_id;
      form["job_type_name"] = values.job_type_name;
      form["effective_date"] = moment(values.effective_date).format("YYYY-MM-DD");
      form["expire_date"] = values.expire_date != undefined ?  moment(values.expire_date).format("YYYY-MM-DD") : null;
      form["is_active"] = 1;
      form["ma_type"] = values.ma_type;
      form["form_id"] = "";
      form["data_dynamic"] = "";
      form["create_date"] = moment(new Date()).format("YYYY-MM-DD HH:mm");
      form["roworder"] = "";;
      form["job_type_id"] = modal_item.job_type_id;

    
      await Api.post("v2/update_job_type", form).then((val) => {
       
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRef.current.resetFields();
          Api.post("/v4/get_job_type", {
            pk_id: null,
            is_active: 1,
            effective: null,
            sql_where: null,
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            UserName: Cookies.get("username"),
          }).then((val) => {
            // console.log(val);
            if (val.data.result.code === "P") {
              this.setState({
                data: val.data.data,
                master_data_job_type: val.data.data,
              });
            }
          });
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });


    } else if (this.state.processType == "add sub") {
      // console.log(values);
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["create_by"] = Cookies.get("userId");
      form["update_by"] = Cookies.get("userId");
      form["project_id"] = Cookies.get("project_id");
      form["job_category_id"] = data_edit.job_category_id;
      form["job_sub_type_id"] = null
      form["job_type_id"] = data_edit.job_type_id;
      form["job_type_name"] = values.sub_type_name;
      form["effective_date"] = moment(values.effective_date).format("YYYY-MM-DD");
      form["expire_date"] = values.expire_date != undefined ?  moment(values.expire_date).format("YYYY-MM-DD") : null;
      form["is_active"] = 1;

      console.log(form);

      await Api.post("update_job_sub_type", form).then((val) => {
       // console.log(val);
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRefSub.current.resetFields();
            //reloadin data
            Api.post("/v2/get_job_sub_type", {
              job_sub_type_id: null,
              job_category_id: data_edit.job_category_id,
              Job_type_id: data_edit.job_type_id,
              is_active: 1,
              effective: null,
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              sql_where: "",
            }).then((val) => {
            // console.log(val);
              if (val.data.result.code === "P") {
                this.setState({
                  data_sub: val.data.data,
                  master_data_sub: val.data.data,
                });
              }
            });
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });

    } else if (this.state.processType == "edit sub") {
    //   console.log("edit sub");
    //  console.log(values);
    //  console.log(modal_item);
     form["company_id"] = Cookies.get("companyid");
     form["operator_id"] = Cookies.get("operator_id");
     form["create_by"] = Cookies.get("userId");
     form["update_by"] = Cookies.get("userId");
     form["project_id"] = Cookies.get("project_id");
     form["job_category_id"] = modal_item.job_category_id;
     form["job_sub_type_id"] = modal_item.job_sub_type_id;
     form["job_type_id"] = modal_item.job_type_id;
     form["job_type_name"] = values.sub_type_name;
     form["effective_date"] = moment(values.effective_date).format("YYYY-MM-DD");
     form["expire_date"] = values.expire_date != undefined ?  moment(values.expire_date).format("YYYY-MM-DD") : null;
     form["is_active"] = this.state.value;


     // console.log(form);

      await Api.post("update_job_sub_type", form).then((val) => {
       // console.log(val);
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRefSub.current.resetFields();
            //reloadin data
            Api.post("/v2/get_job_sub_type", {
              job_sub_type_id: null,
              job_category_id: modal_item.job_category_id,
              Job_type_id: modal_item.job_type_id,
              is_active: 1,
              effective: null,
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              sql_where: "",
            }).then((val) => {
            console.log(val);
              if (val.data.result.code === "P") {
                this.setState({
                  data_sub: val.data.data,
                  master_data_sub: val.data.data,
                });
              }
            });
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });
    }
  }

  async handleDelete() {
    const { modal_item, processType } = this.state;
    var form = {};
    if (processType == "delete") {
      form["create_by"] = Cookies.get("username");
      // form["update_by"] = Cookies.get("userId");
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["project_id"] = Cookies.get("project_id");
      form["job_category_id"] = modal_item.job_category_id;
      form["job_type_name"] = modal_item.job_type_name;
      form["effective_date"] = moment(modal_item.effective_date).format("YYYY-MM-DD");
      form["expire_date"] = modal_item.expire_date != undefined ?  moment(modal_item.expire_date).format("YYYY-MM-DD") : null;
      form["is_active"] = 0;
      form["ma_type"] = modal_item.ma_type;
      form["form_id"] = "";
      form["data_dynamic"] = "";
      form["create_date"] = moment(new Date()).format("YYYY-MM-DD HH:mm");
      form["roworder"] = "";;
      form["job_type_id"] = modal_item.job_type_id;

     // console.log(form);

     await Api.post("v2/update_job_type", form).then((val) => {
      // console.log(val);
       if (val.data.result.code !== "F") {
         this.OnViewApprove(this.renderApproveButtonModal());
         this.setState({
          data: [],
         })
          //   reloadin data
          Api.post("/v4/get_job_type", {
            pk_id: null,
            is_active: 1,
            effective: null,
            sql_where: null,
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            UserName: Cookies.get("username"),
          }).then((val) => {
            // console.log(val);
            if (val.data.result.code === "P") {
              this.setState({
                data: val.data.data,
                master_data_job_type: val.data.data,
                data_sub: [],
                master_data_sub: [],
                data_edit: null,
              });
            }
          });
       } else {
         this.OnViewReject(this.renderRejectButtonModal());
       }
     });


    } else if ("delete sub") {
      console.log(modal_item);
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["create_by"] = modal_item.create_by;
      form["update_by"] = Cookies.get("userId");
      form["project_id"] = Cookies.get("project_id");
      form["job_category_id"] = modal_item.job_category_id;
      form["job_sub_type_id"] = modal_item.job_sub_type_id;
      form["job_type_id"] = modal_item.job_type_id;
      form["job_type_name"] = modal_item.sub_type_name;
      form["effective_date"] = moment(modal_item.effective_date).format("YYYY-MM-DD");
      form["expire_date"] = modal_item.expire_date != undefined ?  moment(modal_item.expire_date).format("YYYY-MM-DD") : null;
      form["is_active"] = 0;

      await Api.post("update_job_sub_type", form).then((val) => {
        // console.log(val);
         if (val.data.result.code !== "F") {
           this.OnViewApprove(this.renderApproveButtonModal());
          //  this.formRefSub.current.resetFields();
          //reloadin data
           Api.post("/v2/get_job_sub_type", {
            job_sub_type_id: null,
            job_category_id: modal_item.job_category_id,
            Job_type_id: modal_item.job_type_id,
            is_active: 1,
            effective: null,
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            sql_where: "",
          }).then((val) => {
          // console.log(val);
            if (val.data.result.code === "P") {
              this.setState({
                data_sub: val.data.data,
              });
            }
          });
         } else {
           this.OnViewReject(this.renderRejectButtonModal());
         }
       });
    }
  }
  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  async onModal(mode, visible, item) {
    if (mode === "add") {
      this.setState({
        mode: mode,
        processType: mode,
        visible: visible,
      });
    } else if (mode === "edit") {
     // console.log(item);
      this.setState({
        mode: mode,
        processType: mode,
        visible: visible,
        modal_item: item,
      });

      {
        setTimeout(() => {
          this.formRef.current.setFieldsValue({
            job_type_name: item.job_type_name,
            job_category_id: item.job_category_id,
            ma_type: item.ma_type,
            effective_date: moment(item.effective_date),
            expire_date:  item.expire_date ? moment(item.expire_date) : null,
            is_active: item.is_active,
          });
        }, 0);
      }
    } else if (mode === "delete") {
      this.setState({
        processType: mode,
        visible_delete: visible,
        modal_item: item,
      });
    } else if (mode === "add sub") {
      this.setState({
        mode: mode,
        processType: mode,
        visible_sub: visible,
      });
    } else if (mode === "edit sub") {
      console.log(item);
      this.setState({
        mode: mode,
        processType: mode,
        visible_sub: visible,
        modal_item: item,
      });
      {
        setTimeout(() => {
          this.formRefSub.current.setFieldsValue({
            sub_type_id: item.job_sub_type_id,
            sub_cat_type_name: item.job_type_name,
            job_category_id: item.job_category_id,
            sub_type_name: item.job_type_name,
            effective_date: moment(item.effective_date),
            expire_date:  item.expire_date ? moment(item.expire_date) : null,
            is_active: item.is_active,
          });
        }, 0);
      }
    } else if (mode === "delete sub") {
      this.setState({
        processType: mode,
        visible_delete: visible,
        modal_item: item,
      });
    }
  }

  NotiModal() {
    const { processType } = this.state;
    if (processType == "add") {
      return "Successfully Added Job Type";
    } else if (processType == "edit") {
      return "Successfully Edited Job Type";
    } else if (processType == "delete") {
      return "Successfully Deleted Job Type";
    } else if (processType == "add sub") {
      return "Successfully Added Job Sub Type";
    } else if (processType == "edit sub") {
      return "Successfully Edited Job Sub Type";
    } else if (processType == "delete sub") {
      return "Successfully Deleted Job Sub Type";
    }
  }

  //Close the modal
  ModalClosed = () => {
    this.setState({
      visible: false,
      visible_sub: false,
      visible_delete: false,
    });
  };

  returnSetFieldValueDate(item) {
    if (!item || item == undefined) {
     // console.log("null");
      return null;
    } else {
     // console.log(item);
      return moment(item);
    }
  }

  async editAssetType(name, item) {
    var form = await item;
    this.onModal(name, "edit", true);
    if (name == "main") {
      this.formRef.current.setFieldsValue({
        asset_type_id: form.asset_type_id,
        asset_group_type: form.asset_group_type,
        asset_type_name: form.asset_type_name,
        ma_type : form.ma_type,
      });
    } else {
     // console.log("==============================");
     // console.log(form);
     // console.log("==============================");
      this.formRef.current.setFieldsValue({
        asset_sub_type_id: form.job_sub_type_id,
        asset_sub_group_type: form.job_category_id,
        asset_sub_type_name: form.job_type_name,
        ma_type : form.ma_type,
      });
    }
  }

  async onClickRow(item) {
    this.setState({
      data_sub : []
    })
    const result = await Api.post("/v2/get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: item.job_category_id,
      Job_type_id: item.job_type_id,
      is_active: 1,
      effective: null,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      sql_where: "",
    });
    console.log(result);
 
    if (result.data.result.code === "P") {
      this.setState({
        data_sub: result.data.data,
        master_data_sub: result.data.data,
        data_edit : item
      });
    } 
  }

  renderModal() {
    const { visible, mode, category, dateFormatList } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            {mode} Job Type
          </span>
        }
        closable={true}
        visible={visible}
        footer={false}
        onCancel={this.ModalClosed}
        destroyOnClose={true}
      >
        <div className="row justify-content-center">
          <div className="col-8">
            <Form
              onFinish={(values) => this.handleSubmit(values)}
              ref={this.formRef}
              layout="vertical"
            >
              {mode === "edit" ? (
                <Form.Item
                  name="is_active"
                  label="Status"
                  rules={[{ required: true, message: "Status is required" }]}
                >
                  <Radio.Group>
                    <Radio value={1}>
                      <span className="font-thai-r fs-18">Active</span>
                    </Radio>
                    <Radio value={0}>
                      <span className="font-thai-r fs-18">Inactive</span>
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              ) : null}

              <Form.Item
                name="job_type_name"
                label="Job Type Name"
                rules={[{ required: true, message: "Full name is required" }]}
              >
                <Input
                  className="inputfile"
                  type="text"
                  size="large"
                  placeholder="Please input"
                  style={{ color: "#0500A3" }}
                  autoComplete="off"
                />
              </Form.Item>
              <Form.Item
                name="job_category_id"
                label="Job Category Name"
                rules={[{ required: true, message: "Role is required" }]}
              >
                <Select
                  style={{ width: "100%" ,color: "#0500A3"}}
                  placeholder="Please select"
                  optionFilterProp="children"
                >
                  {category.map((item, index) => (
                    <Option
                      key={index}
                      value={item.job_category_id}
                      className="inputfile"
                      size="large"
                    >
                      {item.job_category_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="ma_type"
                label="MA Type"
                rules={[{ required: true, message: "MA Type is required" }]}
              >
                <Select
                  style={{ width: "100%",color: "#0500A3" }}
                  placeholder="Please select"
                  optionFilterProp="children"
                >
                    <Option
                      key={"CM"}
                      value={"CM"}
                      className="inputfile"
                      size="large"
                    >
                      CM
                    </Option>
                    <Option
                      key={"PM"}
                      value={"PM"}
                      className="inputfile"
                      size="large"
                    >
                      PM
                    </Option>
                </Select>
   
              </Form.Item>

              <Form.Item
                name="effective_date"
                label="Effective Date"
                rules={[
                  {
                    required: true,
                    message: "Effective Date are required",
                  },
                ]}
              >
                <DatePicker
                  className="inputfile"
                  type="text"
                  size="large"
                  style={{ width: "100%" }}
                  name="size"
                  format={dateFormatList}
                ></DatePicker>
              </Form.Item>

              <Form.Item
                name="expire_date"
                label="Expire Date"
              >
                <DatePicker
                  className="inputfile"
                  type="text"
                  size="large"
                  style={{ width: "100%" }}
                  name="size"
                  format={dateFormatList}
                ></DatePicker>
              </Form.Item>

              <Form.Item className="mb-0 text-center">
                <button
                  type="reset"
                  onClick={() => this.setState({ visible: false })}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
                <button className="btn btn-success">{mode === "edit"? "Edit": "Add"}</button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
    );
  }

  renderModalSub() {
    const { visible_sub, value, mode, sub_category, dateFormatList, category } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            {mode} Asset Sub Type
          </span>
        }
        centered
        visible={visible_sub}
        footer={null}
        closable={false}
        onCancel={this.ModalClosed}
        destroyOnClose={true}
      >
        <Form
          onFinish={(values) => this.handleSubmit(values)}
          layout="vertical"
          ref={this.formRefSub}
        >
          <div className="row">
            <div className="col">
              <div className="d-flex align-items-center">
    
                {mode === "edit sub"?
                      <>
                      <div className="mr-4">
                            <span className="font-thai-r fs-18">Status</span>
                       </div>
                      <Radio.Group onChange={this.onChange} value={value}>
                        <Radio value={1}>
                          <span className="font-thai-r fs-18">Active</span>
                        </Radio>
                        <Radio value={2}>
                          <span className="font-thai-r fs-18">Inactive</span>
                        </Radio>
                      </Radio.Group> 
                      </>        
                : null}
              </div>

              {/* <div className="row">
                  <div className="col">
                  <Form.Item
                        name="job_category_id"
                        label="Job Category Name"
                        rules={[{ required: true, message: "Role is required" }]}
                        >
                          <Select
                            style={{ width: "100%" }}
                            placeholder="Please select"
                            optionFilterProp="children"
                            style={{ color: "#0500A3" }}
                          >
                            {category.map((item, index) => (
                              <Option
                                key={index}
                                value={item.job_category_id}
                                className="inputfile"
                                size="large"
                              >
                                {item.job_category_name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                    </div>
              </div>

              <div className="row">
                <div className="col">
                  <Form.Item
                    name="sub_cat_type_name"
                    label="Asset Sub Group Type"
                    rules={[{ required: true, message: "Role is required" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Please select"
                      optionFilterProp="children"
                    >
                      {sub_category.map((item, index) => (
                        <Option
                          key={index}
                          value={item.job_sub_type_id}
                          className="inputfile"
                          size="large"
                        >
                          {item.job_type_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div> */}
              <div className="row">
                <div className="col-6">
                  <Form.Item
                    name="sub_type_name"
                    label="Asset Sub Type Name"
                    rules={[
                      { required: true, message: "Full name is required" },
                    ]}
                  >
                    <Input
                      className="inputfile"
                      type="text"
                      placeholder="Please input"
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                <Form.Item
                name="effective_date"
                label="Effective Date"
                rules={[
                  {
                    required: true,
                    message: "Effective Date are required",
                  },
                ]}
              >
                <DatePicker
                  className="inputfile"
                  type="text"
                  size="large"
                  style={{ width: "100%" }}
                  name="size"
                  format={dateFormatList}
                ></DatePicker>
              </Form.Item>
              </div>
              <div className="col-6">
                <Form.Item
                  name="expire_date"
                  label="Expire Date"
                  rules={[
                    {
                      required: true,
                      message: "Expire Date are required",
                    },
                  ]}
                >
                  <DatePicker
                    className="inputfile"
                    type="text"
                    size="large"
                    style={{ width: "100%" }}
                    name="size"
                    format={dateFormatList}
                  ></DatePicker>
                </Form.Item>
                </div>
              </div>
            </div>
          </div>

          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => this.setState({ visible_sub: false })}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success">{mode === "edit sub"? "Edit Sub": "Add Sub"}</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  // Opening approve
  OnViewApprove() {
    this.setState({
      visible_approve: true,
    });
  }

  // Open Failed Modal
  OnViewReject() {
    this.setState({
      visible_reject: true,
    });
  }

  renderDelete() {
    const { loading_modal_delete, visible_delete } = this.state;
    // Add Material Form
    return (
      <Fragment>
        <Modal
          title={"Delete Job Category"}
          centered={true}
          visible={visible_delete}
          footer={false}
          destroyOnClose={true}
          onCancel={this.ModalClosed}
        >
          <Spin spinning={loading_modal_delete}>

            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  Are you sure?
                </span>
              </div>
            </div>

            <div
              style={{
                fontFamily: "MontserratM",
                fontWeight: "bold",
                color: "#0500A3",
              }}
            >
              <div>
                <div className="row">
                  <div className="col text-center justify-content-between">
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.setState({ visible_delete: false })}
                      className="btn btn-secondary"
                    >
                      No
                    </button>
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.handleDelete()}
                      className="btn btn-danger"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* </Form> */}
          </Spin>
        </Modal>
      </Fragment>
    );
  }

  //Approve Modal
  renderApproveButtonModal() {
    const { visible_approve } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_approve}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("./icon/approve_check.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 20px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  {this.NotiModal()}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({
                      visible_approve: false,
                      visible_delete: false,
                      visible: false,
                      visible_sub: false,
                    })
                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  //Reject modal
  renderRejectButtonModal() {
    const { visible_reject } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_reject}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/reject.svg")} />
                ) : (
                  <img src={Api.absoluteUrl("./icon/reject.svg")} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  {this.state.error_log != null &&
                  this.state.error_log.includes(
                    "already have material_code:"
                  ) ? (
                    <>
                      <span style={{ color: "red" }}>
                        Add Permission Failed.
                      </span>
                      <br></br>
                      <span style={{ color: "red" }}>
                        {this.state.error_log}
                      </span>
                    </>
                  ) : (
                    <span style={{ color: "red" }}>
                      Submission Failed, Please Check Your Input
                    </span>
                  )}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({ visible_reject: false, visible: false })
                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  SearchJobType = (value) => {
    // console.log(value);
    const {master_data_job_type} = this.state;
    if(value != undefined){
      var setdata = [];
      var obj = {};
          for (let i = 0; i < master_data_job_type.length; i++) {
              for (const [key, value] of Object.entries(master_data_job_type[i])) {
                  if (value == null || value == undefined) {
                  obj[`${key}`] = null
                  } else {
                  obj[`${key}`] = `${value}`
                  }
              }
              setdata.push(obj);
              obj = {};
          }        
      const filter_table = setdata.filter((o) =>
      Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase().trim())
      )
      );

      this.setState({
          data: filter_table
      })
    } else {
      this.setState({
        data: master_data_job_type
    })
    }
  }

  SearchJobSubType = (value) => {
    const {master_data_sub} = this.state;
    if(value != undefined){
      var setdata = [];
      var obj = {};
          for (let i = 0; i < master_data_sub.length; i++) {
              for (const [key, value] of Object.entries(master_data_sub[i])) {
                  if (value == null || value == undefined) {
                  obj[`${key}`] = null
                  } else {
                  obj[`${key}`] = `${value}`
                  }
              }
              setdata.push(obj);
              obj = {};
          }        
      const filter_table = setdata.filter((o) =>
      Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase().trim())
      )
      );
      console.log(filter_table);
      this.setState({
          data_sub: filter_table
      })
    } else {
      this.setState({
        data_sub: master_data_sub
    })
    }
  }

  render() {
    const { data, data_sub, columns, columns_sub, data_edit } = this.state;
    return (
      <div>
        {this.state.visible_approve ? this.renderApproveButtonModal() : null}
        {this.state.visible_reject ? this.renderRejectButtonModal() : null}
        {this.renderDelete()}
        {this.renderModal()}
        {this.renderModalSub()}
        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">Job Type</h3>

        <div className="d-flex justify-content-between m-3">
          <Input.Search
            placeholder="Search"
            onSearch={this.SearchJobType}
            allowClear
            style={{ width: 200 }}
          />

          <button
            className="btn btn-warning"
            onClick={() => this.onModal("add", true)}
          >
            <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
            Add Job Type
          </button>
        </div>
        <Table
          rowKey="job_type_id"
          columns={columns}
          dataSource={data}
        />

        <div
          style={{
            backgroundColor: "#F1F0FF",
            height: "6px",
            width: "100%",
            margin: "20px 0",
          }}
        ></div>
          <span className="font-mont-r fs-12">Basic Data</span>
          <h3 className="font-mont-sb fs-18 c-blue">Job Sub Type</h3>
        <div className="row">
          <div className="col-3 my-3">
            <Input.Search
              placeholder="Search"
              onSearch={this.SearchJobSubType}
              allowClear
              style={{ width: 200 }}
            />
          </div>
          <div className="col-6 text-center font-mont-sb my-3">
              Current selected job type: {data_edit? 
              <div className="c-blue">
              {data_edit.job_type_name != undefined || data_edit.job_type_name != null? data_edit.job_type_name: "-"}
              </div>
              : 
              "-" }
          </div>
          <div className="col-3 text-right my-3">
          {data_edit != null ?
           <button
             className="btn btn-warning"
             onClick={() => this.onModal("add sub", true)}
           >
             <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
             Add Job Sub Type
           </button>
          :null}
         </div>
        </div>

        <Table
          columns={columns_sub}
          dataSource={data_sub}
          rowKey="job_sub_type_id"
        />
      </div>
    );
  }
}
export default JobType;
